"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOptionList = getOptionList;
exports.radioFieldValueFunction = radioFieldValueFunction;
exports.verifyEligibilityToWorkInResidingCountry = verifyEligibilityToWorkInResidingCountry;
exports.shouldSkipEligibilityToWorkInResidingCountryCheck = shouldSkipEligibilityToWorkInResidingCountryCheck;
exports.formatDisplayForOptions = formatDisplayForOptions;

var _constants = require("../../../employee/constants");

function getOptionList(labels) {
  return labels.map(function (label) {
    return {
      label: label,
      value: label
    };
  });
}

function radioFieldValueFunction() {
  return function value(initialValue) {
    if (initialValue == null) return '';
    return initialValue;
  };
}

function verifyEligibilityToWorkInResidingCountry(_ref) {
  var value = _ref.eligibleToWorkInResidingCountry;
  return value ? value !== _constants.booleanCheckValues.NO : false;
}
/**
 * When eligibleToWorkInResidingCountry is undefined it means that we are in the employer onboarding flow,
 * and the elegibilty was set on a previous form.
 * Even if we don't have the value at this point, we are sure that the employee is eligibale to work in the country,
 * because it's mandatory before being allowed to get to contract details form.
 * The value could be changed by users or admins but could never be set to undefined from the UI.
 */


function shouldSkipEligibilityToWorkInResidingCountryCheck(_ref2) {
  var value = _ref2.eligibleToWorkInResidingCountry;
  return typeof value === 'undefined';
}

function formatDisplayForOptions(value) {
  var option = this.options.find(function (o) {
    return o.value === value;
  }); // TODO/IMPROVE later. Perhaps show a tooltip with option.description.

  return option ? option.label : value;
}